import axiosInstance from './axiosInstance';
/**
 * This performRequest function is used to call the service using axios
 * @param {*} method - The HTTP Request Methods
 * @param {*} url - The endpoint url
 * @param {*} headers - The  HTTP headers
 * @param {*} params - The Parameters to be passed for the request
 * @param {*} restOptions - The rest options that axios provides
 * @returns - Response of the axios request
 */
export const performRequest = (method, url, headers, params, restOptions) => {
  const body = method === 'get' ? 'params' : 'data';

  const config = {
    ...restOptions,
    method,
    url,
    headers,
    [body]: params || {},
  };

  return axiosInstance.request(config);
};
